import React from "react";
import { ReviewStars } from "../../../assets/icons";

export default function ReviewCard({ name, country, review, avatar, image }) {
  return (
    <section className="md:[203.73px] flex w-[229.2px] flex-col gap-[14.4px] rounded-[24px]   bg-[#FFFFFF] p-[19.2px] shadow-card_shadow md:gap-[24px] md:p-[32px] 2xl:w-[382px]">
      <header className="flex items-center gap-[9.6px] md:gap-[8.53px] 2xl:gap-[16px]">
        <img
          src={image}
          alt="avatar"
          className="h-[28.8px] w-[28.8px] rounded-full ring-2 ring-white md:h-[25.6px] md:w-[25.6px] 2xl:h-[48px] 2xl:w-[48px]"
        />

        <div>
          <h2 className="mb-1 text-left font-roboto text-[10.8px] font-bold leading-[12.66px] text-[#333333] md:text-[9.6px] md:font-[700] md:leading-[11.25px] 2xl:text-lg 2xl:leading-[21.09px]">
            {name}
          </h2>

          <p className="text-left font-roboto text-[9.6px] font-medium leading-[11.25px] text-[#666A7C] md:text-[8.53px] md:font-[500] md:leading-[10px] 2xl:text-base 2xl:leading-[18.75px]">
            {country}
          </p>
        </div>
      </header>
      <article>
        <p className="text-start font-manrope text-[10.8px] font-semibold leading-[14.04px] text-[#333333] md:text-[9.6px] md:font-[600] md:leading-[12.48px] 2xl:text-[18px] 2xl:leading-[23.4px]">
          {review}
        </p>
      </article>
      <footer>
        <ReviewStars />
      </footer>
    </section>
  );
}
